export default __webpack_public_path__ + "static/media/cedula_nueva.e1a5fd68.svg";